import React, { useEffect, useMemo, useState } from 'react';
const CartIdContext = React.createContext({
    cartId: null,
    setCartId: undefined
});
const CartIdProvider = function CartIdProvider(props) {
    let persistedCartId = null;
    try {
        persistedCartId = localStorage.getItem('cartId') || null;
    }
    catch (e) {
        console.log(e);
    }
    const [cartId, setCartId] = useState(persistedCartId);
    // Mirror state to localStorage
    useEffect(() => {
        if (cartId !== undefined && cartId === persistedCartId)
            return;
        try {
            if (cartId) {
                localStorage.setItem('cartId', cartId);
            }
            else {
                localStorage.removeItem('cartId');
            }
        }
        catch (e) {
            // No local storage
            console.log(e);
        }
    }, [cartId, persistedCartId]);
    const value = useMemo(() => {
        return {
            cartId,
            setCartId
        };
    }, [cartId]);
    return React.createElement(CartIdContext.Provider, Object.assign({ value: value }, props));
};
export { CartIdProvider, CartIdContext };
//# sourceMappingURL=CartIdContext.js.map